import DateInput from 'components/DateInput'
import TimeInput from 'components/TimeInput'
import Translation from 'components/Translation'
import React, { useEffect, useRef, useState } from 'react'
import { classNames } from 'utils/dom-helpers'
import { getTranslation } from 'utils/language-helper'
import { toTitleCase } from 'utils/string-helper'
import { IClass, IClassOption } from '.'
import { RecurrenceSchedule } from '../types'
//@ts-ignore
import { v4 as uuidv4 } from 'uuid'
import { toHHMM } from 'utils/string-localization-helper'
import { useFetch } from '../../../utils/fetch-helper'
import { FetchMethods } from '../../../utils/types'
import { Popup } from '@progress/kendo-react-popup'

export interface IClassItem {
    service: IClassOption[]
    location: IClassOption[]
    instructor: IClassOption[]
    index: number
    setClasses: React.Dispatch<React.SetStateAction<IClass[]>>
    removeClass: (index: number, id: string) => void
    translations?: any
    currentItem: IClass
}

export const days_of_week = [
    'SUNDAY',
    'MONDAY',
    'TUESDAY',
    'WEDNESDAY',
    'THURSDAY',
    'FRIDAY',
    'SATURDAY',
]

const repeatOptions = [
    RecurrenceSchedule.WEEKLY,
    RecurrenceSchedule.MONTHLY_ON_DATE,
    RecurrenceSchedule.MONTHLY_ON_DAY,
    RecurrenceSchedule.DAILY,
]

function isPast(d: unknown): boolean {
    if (d == undefined) return false
    return (
        (d as Date).toISOString().substr(0, 10) <
        new Date().toISOString().substr(0, 10)
    )
}

const init = { id: '', name: '' }

const ClassItem: React.FC<IClassItem> = ({
    location,
    service,
    instructor,
    index,
    setClasses,
    removeClass,
    translations,
    currentItem,
}) => {
    const {
        id,
        repeats,
        endDate,
        isRecurring,
        date: startDate,
    } = currentItem
    const [selectedService, setSelectedService] = useState(init)
    const [selectedLocation, setSelectedLocation] = useState(init)
    const [selectedInstructor, setSelectedInstructor] = useState(init)
    const [hasEndDate, sethasEndDate] = useState(false)
    const [error, setError] = useState('')
    const [displayedDay, setDisplayedDay] = useState(
        days_of_week[new Date().getDay()]
    )
    const [spaces, setSpaces] = useState<Record<string, string>[]>([])
    const icon_ref = useRef<HTMLInputElement>(null)
    const [show_not_allowed, setNotAllowed] = useState(false)

    const duplicateClass = () => {
        const newClass: IClass = {
            id: uuidv4(),
            service: currentItem.service,
            location: currentItem.location,
            locationSpace: currentItem.locationSpace,
            instructor: currentItem.instructor,
            endDate,
            repeats: currentItem.repeats,
            isRecurring,
            date: new Date(),
            time: toHHMM(new Date()),
            day: days_of_week[new Date().getDay()],
        }
        setClasses((prev) => {
            return prev.length < 5 ? [...prev, newClass] : prev
        })
    }

    const {
        data: location_spaces,
        is_loading: is_fetching_spaces,
        doFetch: getLocationSpaces,
    } = useFetch(
        `/v1/location-spaces/location-id?locationId=${currentItem.location.id}`,
        FetchMethods.GET
    )

    useEffect(() => {
        if (location_spaces.content) {
            const spaces =
                location_spaces &&
                location_spaces.content &&
                location_spaces.numberOfElements > 0
                    ? location_spaces.content.map(
                          (space: Record<string, string>) => ({
                              value: space.id,
                              text: space.name,
                          })
                      )
                    : []
            setSpaces(spaces)
            setClasses((prev) => {
                const prevState = [...prev]
                prevState[index].locationSpace = spaces[0]
                return prevState
            })
        }
    }, [location_spaces])

    return (
        <div className="mb-1 bg-primary-lighter bg-opacity-40">
            <div
                className={classNames(
                    'flex gap-2 px-1 h-16 overflow-visible items-center '
                )}
            >
                <div
                    className="place-items-stretch "
                    style={{ width: '15%' }}
                >
                    <select
                        style={{ width: '100%' }}
                        id="service"
                        name="service"
                        className={`focus:ring-primary-light focus:border-primary-light shadow-sm border-gray-300 rounded-md text-sm `}
                        value={currentItem.service?.id || ''}
                        onChange={(e) => {
                            getLocationSpaces()
                            const currentService = service.find(
                                (item) => item.id === e.target.value
                            )
                            setSelectedService(
                                currentService as IClassOption
                            )
                            setClasses((prevState: IClass[]) => {
                                const prev = [...prevState]
                                prev[index].service = {
                                    id: e.target.value,
                                    name: currentService?.name || '',
                                    slots: currentService?.slots,
                                }
                                return prev
                            })
                        }}
                    >
                        {service?.map((loc) => (
                            <option value={loc.id} key={loc.id}>
                                {loc.name}
                            </option>
                        ))}
                    </select>
                </div>
                <div
                    className="place-items-stretch "
                    style={{ width: '17%' }}
                >
                    <select
                        style={{ width: '100%' }}
                        id="location"
                        name="location"
                        className={`focus:ring-primary-light focus:border-primary-light shadow-sm border-gray-300 rounded-md text-sm `}
                        value={currentItem.location?.id || ''}
                        onChange={(e) => {
                            const currentLocation = location.find(
                                (item) => item.id === e.target.value
                            )

                            setSelectedLocation(
                                currentLocation as IClassOption
                            )

                            setClasses((prevState: IClass[]) => {
                                const prev = [...prevState]
                                prev[index].location = {
                                    id: e.target.value,
                                    name: currentLocation?.name || '',
                                }
                                return prev
                            })
                        }}
                    >
                        {location?.map((loc) => (
                            <option value={loc.id} key={loc.id}>
                                {loc.name}
                            </option>
                        ))}
                    </select>
                </div>
                <div
                    className="w-40 px-1"
                    ref={icon_ref}
                    onMouseEnter={() => {
                        if (is_fetching_spaces) {
                            setNotAllowed(true)
                        }
                    }}
                    onMouseLeave={() => {
                        if (show_not_allowed) {
                            setNotAllowed(false)
                        }
                    }}
                >
                    {spaces?.length ? (
                        <select
                            id="location-space"
                            name="location-space"
                            className={`w-full focus:ring-primary-light focus:border-primary-light shadow-sm border-gray-300 rounded-md text-sm`}
                            onChange={(e) => {
                                setClasses((prevState: IClass[]) => {
                                    const prev = [...prevState]
                                    prev[index].locationSpace = {
                                        value: e.target.value,
                                        name: e.target.name || '',
                                    }
                                    return prev
                                })
                            }}
                            value={currentItem.locationSpace?.value || ''}
                        >
                            {spaces.map(
                                ({
                                    text,
                                    value,
                                }: Record<string, string>) => (
                                    <option key={value} value={value}>
                                        {text}
                                    </option>
                                )
                            )}
                        </select>
                    ) : !is_fetching_spaces ? (
                        <div>
                            <Translation
                                render_as="div"
                                className={`w-full focus:ring-primary-light focus:border-primary-light shadow-sm border-gray-300 rounded-md text-sm`}
                                content_key="no_spaces_available"
                            />
                            <Popup
                                anchor={icon_ref.current}
                                show={show_not_allowed}
                                animate={false}
                                popupAlign={{
                                    horizontal: 'left',
                                    vertical: 'top',
                                }}
                                popupClass={
                                    'bg-black text-white text-xs shadow-lg rounded-xl w-auto px-2 py-1 mt-2'
                                }
                                className="z-[102]"
                            >
                                <Translation
                                    render_as="p"
                                    content_key="no_spaces_popup"
                                />
                            </Popup>
                        </div>
                    ) : (
                        <div className="bg-white w-full block h-full bg-gray-150 rounded-lg" />
                    )}
                </div>
                <div
                    className="place-items-stretch"
                    style={{ width: '15%' }}
                >
                    <select
                        style={{ width: '100%' }}
                        id="instructor"
                        name="instructor"
                        className={`focus:ring-primary-light focus:border-primary-light shadow-sm border-gray-300 rounded-md text-sm `}
                        value={currentItem.instructor?.id || ''}
                        onChange={(e) => {
                            const currentInstructor = instructor.find(
                                (item) => item.id === e.target.value
                            )

                            setSelectedInstructor(
                                currentInstructor as IClassOption
                            )

                            setClasses((prevState: IClass[]) => {
                                const prev = [...prevState]
                                prev[index].instructor = {
                                    id: e.target.value,
                                    name: currentInstructor?.name || '',
                                }
                                return prev
                            })
                        }}
                    >
                        {instructor?.map((loc) => (
                            <option value={loc.id} key={loc.id}>
                                {loc.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div
                    className="w-36  place-items-stretch px-1"
                    style={{ width: '20%' }}
                >
                    <div
                        style={{ borderWidth: '1px' }}
                        className="flex items-stretch focus:ring-primary-light focus:border-primary-light w-full shadow-sm border-gray-300 rounded-md calendar text-sm"
                    >
                        <DateInput
                            id={`classDate${index}`}
                            minDate={new Date()}
                            className={classNames(
                                '  block w-full rounded-l-md calendar text-sm border-0 focus:ring-0'
                            )}
                            onChange={(date: any) => {
                                setDisplayedDay(days_of_week[date.getDay()])
                                setClasses((prevState) => {
                                    const prev = [...prevState]
                                    prev[index].date = date
                                    prev[index].day =
                                        days_of_week[date.getDay()]

                                    return prev
                                })
                            }}
                            dateFormat="dd/MM/yyyy"
                            selected={startDate}
                        />{' '}
                        <div
                            className={classNames(
                                'flex items-center rounded-r-md',
                                'bg-white'
                            )}
                        >
                            <label htmlFor={`classDate${index}`}>
                                <i className="feather-calendar pr-2 "></i>
                            </label>
                        </div>
                    </div>
                </div>
                <div className="w-32" style={{ width: '20%' }}>
                    <TimeInput
                        onChange={(e) => {
                            if (e.target.value) {
                                const time = toHHMM(e.target.value as Date)
                                setClasses((prev: IClass[]) => {
                                    const prevState = [...prev]
                                    prevState[index].time = time
                                    return prevState
                                })
                            }
                        }}
                        defaultValue={new Date()}
                        popupSettings={{
                            popupClass: "z-[102]"
                        }}
                    />
                </div>

                <div
                    className="flex-1 items-center flex px-1 gap-2 "
                    style={{ width: '20%' }}
                >
                    <input
                        id={`check_${index}`}
                        className={classNames(
                            'h-6 w-6 border-gray-300 rounded focus:ring-primary-light',
                            isPast(new Date())
                                ? 'text-gray-200'
                                : 'text-primary'
                        )}
                        type="checkbox"
                        defaultChecked={isRecurring}
                        onChange={(v) =>
                            setClasses((prevState: IClass[]) => {
                                const prev = [...prevState]
                                prev[index].isRecurring = v.target.checked
                                return prev
                            })
                        }
                    />

                    <Translation
                        render_as="label"
                        htmlFor={`check_${index}`}
                        content_key="recurring_label"
                    />
                    <div className="flex-1" />
                    <button
                        type="button"
                        className={`text-primary bg-opacity-30 h-10 w-10 rounded-lg text-xl feather-copy`}
                        onClick={() => duplicateClass()}
                    />
                    <button
                        type="button"
                        className={`text-red-500 bg-red-100 h-10 w-10 rounded-lg text-xl feather-trash-2`}
                        onClick={() => removeClass(index, id)}
                    />
                </div>
            </div>
            <div
                className={classNames(
                    'w-full flex gap-6',
                    isRecurring
                        ? 'bg-gray-50 py-4 border-t border-primary-lighter'
                        : ''
                )}
            >
                {isRecurring ? (
                    <>
                        <label
                            htmlFor="day_of_week"
                            className="flex gap-3 items-center w-60 justify-end mr-10"
                        >
                            <Translation content_key="day_label" />
                            <select
                                disabled
                                id="day_of_week"
                                name="day_of_week"
                                className="focus:ring-primary-light focus:border-primary-light shadow-sm border-gray-300 rounded-md text-sm"
                                onChange={(v) => {
                                    setClasses((prevState) => {
                                        const newState = [...prevState]
                                        newState[index].day = v.target.value
                                        return []
                                    })
                                }}
                                value={displayedDay}
                            >
                                {days_of_week.map((d: string) => (
                                    <option key={d} value={d}>
                                        {toTitleCase(
                                            getTranslation(d, translations)
                                        )}
                                    </option>
                                ))}
                            </select>
                        </label>

                        <label
                            htmlFor="repeats"
                            className="flex gap-3 items-center w-48 justify-end"
                        >
                            <Translation content_key="repeats_label" />
                            <div className="w-40">
                                <select
                                    disabled={false}
                                    id="repeats"
                                    name="repeats"
                                    className={`w-40 focus:ring-primary-light focus:border-primary-light shadow-sm border-gray-300 rounded-md text-sm `}
                                    onChange={(v) => {
                                        setClasses((prev) => {
                                            const newState = [...prev]
                                            newState[index].repeats =
                                                v.target.value
                                            return newState
                                        })
                                    }}
                                >
                                    {repeatOptions.map((d: string) => (
                                        <option key={d} value={d}>
                                            {translations[
                                                d.toLowerCase()
                                            ] || d.toLowerCase()}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </label>

                        <div className="flex-1" />

                        <label
                            htmlFor="end_date"
                            className="flex gap-1 items-center w-60"
                        >
                            <Translation content_key="end_date_label" />
                            {hasEndDate ? (
                                <>
                                    <div className="flex items-center gap-1">
                                        <div className="w-36">
                                            <DateInput
                                                minDate={new Date()}
                                                id="ends_at"
                                                className="focus:ring-primary-light focus:border-primary-light block w-full shadow-sm border-gray-300 rounded-md calendar text-sm"
                                                onChange={(date: Date) => {
                                                    if (date < startDate) {
                                                        setError(
                                                            "Can't set End Date before Starting Date"
                                                        )
                                                    } else {
                                                        setClasses(
                                                            (prev) => {
                                                                const newState =
                                                                    [
                                                                        ...prev,
                                                                    ]
                                                                newState[
                                                                    index
                                                                ].endDate = date
                                                                return newState
                                                            }
                                                        )
                                                    }
                                                }}
                                                dateFormat="dd/MM/yyyy"
                                                selected={endDate as Date}
                                            />
                                        </div>
                                        <i
                                            className="feather-x-circle text-primary-light text-lg cursor-pointer"
                                            onClick={() => {
                                                setError('')
                                                setClasses((prev) => {
                                                    const newState = [
                                                        ...prev,
                                                    ]
                                                    newState[
                                                        index
                                                    ].endDate = ''
                                                    return newState
                                                })
                                                sethasEndDate(false)
                                            }}
                                        />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <i className="feather-plus text-primary-light text-lg" />
                                    <div
                                        className="text-primary-light font-sans font-light text-base cursor-pointer"
                                        onClick={() => {
                                            sethasEndDate((prev) => !prev)
                                        }}
                                    >
                                        <Translation
                                            render_as="div"
                                            content_key="set_end_date_label"
                                        />
                                    </div>
                                </>
                            )}
                        </label>
                    </>
                ) : (
                    ''
                )}
            </div>
            {!!error.length && (
                <span
                    style={{ color: 'red' }}
                    className="flex justify-center"
                >
                    {error}
                </span>
            )}
        </div>
    )
}
export default ClassItem
